export default __webpack_public_path__ + "static/media/img-05.a3e11ba4.jpg";